import analogueAtticCover from './img/analogueAtticCover.jpg';
import analogueAtticCover2 from './img/analogueAtticCover2.jpg';
import analogueAtticCover3 from './img/analogueAtticCover3.jpg';
import analogueAtticCover4 from './img/analogueAtticCover4.jpg';
import analogueAtticLogo from './img/analogueAttic.jpg';
import animalsDancingLogo from './img/animalsDancing.jpg';
import apparelMusicLogo from './img/apparelMusic.jpg';
import churchCover from './img/churchCover.jpg';
import churchLogo from './img/church.jpg';
import clippArtLogo from './img/clippArt.jpg';
import coastalHazeLogo from './img/coastalHaze.jpg';
import delusionsOfGrandeurLogo from './img/delusionsOfGrandeur.jpg';
import lateNightTalesLogo from './img/lateNightTales.jpg';
import letsPlayHouseLogo from './img/letsPlayHouse.jpg';
import lobsterThereminLogo from './img/lobsterTheremin.jpg';
import mrBongoLogo from './img/mrBongo.jpg';
import shallNotFadeLogo from './img/shallNotFade.jpg';
import slothBoogieLogo from './img/slothBoogie.jpg';
import soulClapCover from './img/soulClapCover.jpg';





export const images = {
	analogueAttic: {logo: analogueAtticLogo, cover: analogueAtticCover, cover2: analogueAtticCover2, cover3: analogueAtticCover3, cover4: analogueAtticCover4 },
	animalsDancing: {logo: animalsDancingLogo},
	apparelMusic: {logo: apparelMusicLogo},
	church: {logo: churchLogo, cover: churchCover},
	clippArt: {logo: clippArtLogo},
	coastalHaze: {logo: coastalHazeLogo},
	delusionsOfGrandeur: {logo: delusionsOfGrandeurLogo},
	lateNightTales: {logo: lateNightTalesLogo},
	letsPlayHouse: {logo: letsPlayHouseLogo},
	lobsterTheremin: {logo: lobsterThereminLogo},
	mrBongo: {logo: mrBongoLogo},
	shallNotFade: {logo: shallNotFadeLogo},
	slothBoogie: {logo: slothBoogieLogo},

	soulClap: {cover: soulClapCover},
}

	
